import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Badge as MuiBadge,
  Box,
  Stack,
  Button,
} from '@mui/material';
import { Star, MapPin, Wifi, Car, UtensilsCrossed, Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import { ImageWithFallback } from '../figma/ImageWithFallback';
import axios from 'axios'; 
import { KeyUri } from "../key";
import { useNavigate } from 'react-router-dom';
import SafeImage, { normalizeImages } from "../Global/SafeTmage";
export function PropertyCard({ property, onSelect }) {
    const navigate = useNavigate();
  const href = `/hotel/property/${property._id}`;
  const [isFavorite, setIsFavorite] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [hotelPricing, setHotelPricing] = useState(null);
  const [pricingLoading, setPricingLoading] = useState(true);

  //const images = property.images || [];
  const images = normalizeImages(property.images);
  const hasMultipleImages = images.length > 1;

  const handlePrevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };
  const accommodations = property.accommodations || [];
 const minPrice = accommodations.length
  ? Math.min(...accommodations.map(acc => acc.pricePerNightB2C || 0))
  : 0;


  // Flatten amenities object to string array for display
  const amenitiesObj = property.amenities || {};
  const allAmenities = [
    ...(amenitiesObj.general || []),
    ...(amenitiesObj.recreational || []),
    ...(amenitiesObj.dining || []),
    ...(amenitiesObj.services || []),
  ];

  // Show up to 3 top amenities
  
  
  const topAmenities = allAmenities.slice(0, 3).map(name => ({ name, available: true }));
//console.log('accommodations:', property.accommodations);

  // Map of amenity names to icons
  const amenityIcons = {
    'WiFi': Wifi,
    'Free WiFi': Wifi,
    'Parking': Car,
    'Free Parking': Car,
    'Restaurant': UtensilsCrossed,
    'Dining': UtensilsCrossed,
  };

useEffect(() => {
  async function fetchHotelPricing() {
    try {
     
      const res = await axios.get(`${KeyUri.BACKEND_URI}/get-hotelpricing`);
      
    
      setHotelPricing(res.data.data);
      
    } catch (err) {
     
      console.error(' Hotel pricing failed:', {
        status: err.response?.status,
        data: err.response?.data,
        message: err.message
      });
      setHotelPricing(null);
    } finally {
      setPricingLoading(false);
    }
  }
  
  fetchHotelPricing();
}, []);



const getTotalPrice = () => {
  if (!hotelPricing || pricingLoading) return minPrice;
  
  const {
    platform_price = 0,          // e.g. 3% → only this as percentage
    miscellaneous_charges = 0,   // fixed
    additional_charges_one = 0,  // fixed
    additional_charges_two = 0,  // fixed
   
  } = hotelPricing;

 
  const platformAmount = (minPrice * platform_price) / 100;
  
 
  const fixedFees = miscellaneous_charges + additional_charges_one + additional_charges_two;
  
  
  const totalFees = platformAmount + fixedFees;
  const totalPrice = minPrice + totalFees;
  
  return totalPrice;
};


  const totalPrice = getTotalPrice();
  return (
   <a   href={href}
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey || e.button === 1) return;
        e.preventDefault();
        navigate(href);
      }}
      style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
    >
      <Card
        sx={{ width: '100%', cursor: 'pointer', transition: 'box-shadow 0.3s', '&:hover': { boxShadow: 6 } , marginBottom: 4}}
        onClick={() => onSelect(property._id)}
      >
        <Box sx={{ position: 'relative', height: 224, overflow: 'hidden' }}>
       <SafeImage
  src={images[currentImageIndex]}
  type="hotel"
  alt={property.propertyName}
  className="property-image"
  sx={{ transition: 'transform 0.3s' }}
/>

          {/* Navigation Arrows */}
          {hasMultipleImages && currentImageIndex > 0 && (
            <IconButton
              aria-label="previous image"
              onClick={handlePrevImage}
              sx={{
                position: 'absolute',
                left: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                bgcolor: 'rgba(255,255,255,0.85)',
                '&:hover': { bgcolor: 'white' },
                width: 32,
                height: 32,
                opacity: 0,
                transition: 'opacity 0.2s',
                '.MuiCard-root:hover &': { opacity: 1 },
              }}
            >
              <ChevronLeft size={18} />
            </IconButton>
          )}
          {hasMultipleImages && currentImageIndex < images.length - 1 && (
            <IconButton
              aria-label="next image"
              onClick={handleNextImage}
              sx={{
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                bgcolor: 'rgba(255,255,255,0.85)',
                '&:hover': { bgcolor: 'white' },
                width: 32,
                height: 32,
                opacity: 0,
                transition: 'opacity 0.2s',
                '.MuiCard-root:hover &': { opacity: 1 },
              }}
            >
              <ChevronRight size={18} />
            </IconButton>
          )}

          {/* Dot Indicators */}
          {hasMultipleImages && (
            <Box
              sx={{
                position: 'absolute',
                bottom: 8,
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: 0.5,
              }}
            >
              {images.slice(0, 5).map((_, idx) => (
                <Box
                  key={idx}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImageIndex(idx);
                  }}
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    bgcolor: currentImageIndex === idx ? 'white' : 'rgba(255,255,255,0.5)',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    '&:hover': { bgcolor: 'white' },
                  }}
                />
              ))}
              {images.length > 5 && (
                <Typography variant="caption" sx={{ color: 'white', fontSize: 10, ml: 0.5 }}>
                  +{images.length - 5}
                </Typography>
              )}
            </Box>
          )}

          {/* Property Type Badge */}
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              left: 8,
              bgcolor: '#ffffff',
              borderRadius: 8,
              py: 0.75,
              px: 1.75,
              boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
              border: '1px solid rgba(255,255,255,0.9)',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="caption"
              component="span"
              fontWeight={700}
              fontSize={12}
              sx={{
                whiteSpace: 'nowrap',
                lineHeight: 1.2
              }}
            >
              {property.propertyType}
            </Typography>
          </Box>
        </Box>

        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
            <Typography variant="h6" noWrap flex={1}>{property.propertyName}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1 }}>
              {/* <Star size={16} color="#fbbf24" />
             <Typography variant="body2">{property.averageRating}</Typography>
              <Typography variant="body2" color="text.secondary">({property.totalReviews})</Typography>*/}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1, color: 'text.secondary' }}>
            <MapPin size={16} />
            <Typography variant="body2">{property.location?.city}, {property.location?.state}</Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" noWrap sx={{ mb: 2 }}>
            {property.description}
          </Typography>

          <Stack direction="row" spacing={1} flexWrap="wrap" mb={2}>
            {topAmenities.map((amenity, index) => {
              const Icon = amenityIcons[amenity.name];
              return (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, bgcolor: 'grey.100', borderRadius: 1, px: 1, py: 0.5 }}>
                  {Icon && <Icon size={14} color="#4b5563" />}
                  <Typography variant="caption" color="text.primary">{amenity.name}</Typography>
                </Box>
              );
            })}
          </Stack>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 2, borderTop: '1px solid', borderColor: 'grey.200' }}>
           {/*} <Box>
              <Typography variant="caption" color="text.secondary">Starting from</Typography>
              <Typography variant="h6" color="text.primary">
                ₹{minPrice.toLocaleString('en-IN')} <Typography component="span" variant="caption" color="text.secondary">/night</Typography>
              </Typography>
            </Box>*/}
            <Box>
              <Typography variant="caption" color="text.secondary">
                Starting from
              </Typography>
              <Typography variant="h6" color="text.primary">
                {pricingLoading ? (
                  '₹--'
                ) : (
                  <>
                    ₹{totalPrice.toLocaleString('en-IN')} 
                    <Typography component="span" variant="caption" color="text.secondary">
                      /night
                    </Typography>
                  </>
                )}
              </Typography>
            </Box>
            <a href={href}
              onClick={(e) => {
                e.stopPropagation(); // don't bubble to outer <a>
                if (e.ctrlKey || e.metaKey || e.button === 1) return;
                e.preventDefault();
                navigate(href);
              }}
            >
              <Button variant="contained" size="small" component="span">
                View Details
              </Button>
              </a>
          </Box>
        </CardContent>
      </Card>
    </a>
  );
}
